export default __webpack_public_path__ + "static/media/02.fba77736.jpg";